import { render, staticRenderFns } from "./EditMarsAlert.vue?vue&type=template&id=13e5bf9c&"
import script from "./EditMarsAlert.vue?vue&type=script&lang=js&"
export * from "./EditMarsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports